import apiClient from "../../axios/apiClient";

export const getMasterSettings = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_SETTINGS_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Master/Settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_SETTINGS_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_SETTINGS_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllStateList =
  (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MASTER_STATE_PENDING" });

        const response = await apiClient.get(
          `/api/v1/master/states`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MASTER_STATE_FULFILLED",
          payload: response.data?.data,
        });
      } catch (error) {
        dispatch({
          type: "GET_MASTER_STATE_REJECTED",
          payload: error.response,
        });
      }
    };

export const getMasterVehicleListJenWise = (token, jenId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_VEHICLE_JEN_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/vehicles/?jenId=${jenId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            jenId,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_VEHICLE_JEN_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_VEHICLE_JEN_WISE_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterHydrantList = (token, jenId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_HYDRANT_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/hydrants/?jenId=${jenId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            
          },
        }
      );
      dispatch({
        type: "GET_MASTER_HYDRANT_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_HYDRANT_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllCityStateWiseList = (token, stateId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CITY_STATE_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/cities`,
        {
          params: {
            stateCode: stateId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      dispatch({
        type: "GET_MASTER_CITY_STATE_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      if (error.response) {
      }
      dispatch({
        type: "GET_MASTER_CITY_STATE_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getAllUsersRoleWiseList = (token, roleCode) =>
  async (dispatch) => {
    console.log('roleCode:', roleCode);
    try {
      dispatch({ type: "GET_MASTER_USERS_ROLE_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/users/${roleCode}`,
        {
          
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      console.log('response.data?.data', response.data?.data);
      dispatch({
        type: "GET_MASTER_USERS_ROLE_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      console.log(error);
      if (error.response) {
        console.error('Error Response Data:', error.response.data);
        console.error('Error Response Status:', error.response.status);
        console.error('Error Response Headers:', error.response.headers);
      }
      dispatch({
        type: "GET_MASTER_USERS_ROLE_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterDestinationList = (token, jenId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_DESTINATION_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/destinations`,
        {
          params: {
            jenId: jenId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          
          },
        }
      );
      dispatch({
        type: "GET_MASTER_DESTINATION_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_DESTINATION_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterVehicleList = (token,jenId, vendorId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_VEHICLE_PENDING" });
       const response = await apiClient.get(
        `/api/v1/master/vehicles`,
        {
          params: {
            jenId: jenId,
            vendorId: vendorId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_VEHICLE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_VEHICLE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterDriverList = (token, jenId, vendorId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_DRIVER_PENDING" });
      let url = `/api/v1/master/drivers`;
      
      const response = await apiClient.get(url,
        {
          params: {
            jenId: jenId,
            vendorId: vendorId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_DRIVER_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_DRIVER_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterVendorList = (token, jenId) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_VENDOR_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/vendors`,
        {
          params: {
            jenId: jenId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_VENDOR_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_VENDOR_REJECTED",
        payload: error.response,
      });
    }
  };
  

export const getMasterUsertypeList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USERTYPE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/roles`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_USERTYPE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_USERTYPE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterUsertypeUserWiseList = (token,roleCode) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USERTYPE_USER_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/reporting-to`,
        {
          params:{
            roleCode, 
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterUsertypeCircleReportWiseList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USERTYPE_USER_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/usertype-circle-report`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAllUsertypeUserList = (token, user_type, city) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USERTYPE_USER_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/user-usertype-city-wise`,
        {
          params: {
            user_type: user_type,
            city: city,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      if (error.response) {
      }
      dispatch({
        type: "GET_MASTER_USERTYPE_USER_REJECTED",
        payload: error.response,
      });
    }
  };


export const getAddressByLatLng = (lat, lng) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_REVERSE_GEOCODING_PENDING" });

      const response = await apiClient.get(
        `https://mapapi.asginnovations.in/v1/reverse?point.lat=${lat}&point.lon=${lng}&size=1&layers=coarse,venue,address`,
        {
          headers: {
            'X-API-Key': 'asginnovationsdemoapikey',
          },
        }
      );
      dispatch({
        type: "GET_REVERSE_GEOCODING_FULFILLED",
        payload: response.data?.features[0].properties,
      });
    } catch (error) {
      dispatch({
        type: "GET_REVERSE_GEOCODING_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterBlockBookingList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_BLOCK_BOOKING_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/block`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_BLOCK_BOOKING_LIST_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_BLOCK_BOOKING_LIST_REJECTED",
        payload: error.response,
      });
    }
  };



export const getMasterSarpanchBookingList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_SARPANCH_BOOKING_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/sarpanch`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_MASTER_SARPANCH_BOOKING_LIST_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      dispatch({
        type: "GET_MASTER_SARPANCH_BOOKING_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterUserUserTypeWiseList = (token, roleCode) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_USER_USERTYPE_WISE_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/users/${roleCode}`,
        {

          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      dispatch({
        type: "GET_MASTER_USER_USERTYPE_WISE_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      if (error.response) {
      }
      dispatch({
        type: "GET_MASTER_USER_USERTYPE_WISE_REJECTED",
        payload: error.response,
      });
    }
  };


export const getMasterCameraList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CAMERA_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/cameras`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      dispatch({
        type: "GET_MASTER_CAMERA_LIST_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      if (error.response) {
      }
      dispatch({
        type: "GET_MASTER_CAMERA_LIST_REJECTED",
        payload: error.response,
      });
    }
  };

export const getMasterCameraNvrList = (token) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_MASTER_CAMERA_NVR_LIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/master/nvrs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json"
          },
        }
      );
      dispatch({
        type: "GET_MASTER_CAMERA_NVR_LIST_FULFILLED",
        payload: response.data?.data,
      });
    } catch (error) {
      if (error.response) {
      }
      dispatch({
        type: "GET_MASTER_CAMERA_NVR_LIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const getVolveConfigurationList = (token) =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_MASTER_VOLVE_CONFIGURATION_LIST_PENDING" });
  
        const response = await apiClient.get(
          `/api/v1/master/volve-configuration`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_MASTER_VOLVE_CONFIGURATION_LIST_FULFILLED",
          payload: response.data?.data,
        });
      } catch (error) {
        dispatch({
          type: "GET_MASTER_VOLVE_CONFIGURATION_LIST_REJECTED",
          payload: error.response,
        });
      }
    };

    export const getCameraUnusedList = (token) =>
      async (dispatch) => {
        try {
          dispatch({ type: "GET_MASTER_UNUSED_CAMERA_LIST_PENDING" });
    
          const response = await apiClient.get(
            `/api/v1/master/cameras/unused`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          dispatch({
            type: "GET_MASTER_UNUSED_CAMERA_LIST_FULFILLED",
            payload: response.data?.data,
          });
        } catch (error) {
          dispatch({
            type: "GET_MASTER_UNUSED_CAMERA_LIST_REJECTED",
            payload: error.response,
          });
        }
      };